<div>
  @if (showTitle) {
    <h5 class="mb-3">Subscribe to Newsletter</h5>
  }

  <form (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <input type="email" name="email" [(ngModel)]="form.email" class="form-control"
        placeholder="Your email address" required>
    </div>
    <button type="submit" class="btn btn-primary w-100">Subscribe</button>
  </form>
  @if (successMessage) {
    <p class="success-message">{{ successMessage }}</p>
  }
</div>
